// Форматирование ожидаемой даты доставки для кнопок карточек.
//
// Показываем дату, а не «через N дней»: покупателю проще соотнести её
// со своими планами. Берётся верхняя граница срока — обещать раньше,
// чем СДЭК гарантирует, нельзя.

const MONTHS = [
  "января", "февраля", "марта", "апреля", "мая", "июня",
  "июля", "августа", "сентября", "октября", "ноября", "декабря",
];

// Производство считается в рабочих днях, перевозка — в календарных
export const workingDaysToCalendar = (days) => {
  const value = Number(days) || 0;
  if (value <= 0) return 0;
  return value + Math.floor(value / 5) * 2;
};

export const deliveryDate = (days, from = new Date()) => {
  const date = new Date(from);
  date.setDate(date.getDate() + (Number(days) || 0));
  return date;
};

export const formatDeliveryDate = (days, from = new Date()) => {
  const value = Number(days) || 0;
  if (value <= 0) return "Сегодня";
  if (value === 1) return "Завтра";
  if (value === 2) return "Послезавтра";

  const date = deliveryDate(value, from);
  return `${date.getDate()} ${MONTHS[date.getMonth()]}`;
};
